import { appFlawCatalog } from './appFlawCatalog.js';
import { buildAppFlawEvidenceSchema } from './appFlawCatalog/buildAppFlawEvidenceSchema.js';

const codeEvidenceSchemas = Object.fromEntries(
  Object.entries(appFlawCatalog)
    .filter(([, flaw]) => flaw.detectionModes.includes('code'))
    .map(([slug, flaw]) => [slug, buildAppFlawEvidenceSchema({ ...flaw, evidenceAlternatives: flaw.codeEvidenceAlternatives || flaw.evidenceAlternatives })])
);

export const isAppFlawCodeEvidence = ({ flawSlug, evidence }) => {
  if (!Object.hasOwn(codeEvidenceSchemas, flawSlug)) {
    return false;
  }
  return codeEvidenceSchemas[flawSlug].safeParse(evidence).success;
};
